import { useState, useEffect } from 'react';
import { signAndPostLoginChallenge } from '../utils/loginSign';
import type { LocalIdentity } from '../types/identity';

type Status = 'idle' | 'signing' | 'done' | 'error';

export function useSignAndPostLogin(
  hash: string,
  nonce: string,
  identity: LocalIdentity | null,
): { status: Status; error: string | null } {
  const [status, setStatus] = useState<Status>('idle');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (hash === '' || nonce === '' || identity === null || status !== 'idle') {
      return;
    }
    const pk = identity.privateKey;
    if (pk === undefined) {
      setError(`Déverrouillez l${"'"}identité pour signer.`);
      setStatus('error');
      return;
    }
    setStatus('signing');
    signAndPostLoginChallenge(hash, nonce, pk, identity.publicKey)
      .then((ok) => {
        setStatus(ok === 0 ? 'error' : 'done');
        if (ok === 0) {
          setError('Échec publication sur tous les relais.');
        }
      })
      .catch((err) => {
        console.error('signAndPostLoginChallenge failed:', err);
        setError('Erreur lors de la signature.');
        setStatus('error');
      });
  }, [hash, nonce, identity, status]);

  return { status, error };
}
